import asyncActionTypes from '../actions/types.js';
import { setCookie, deleteCookie, getCookie } from '../../scripts/utilities/helpers';
import safeLocalStorage from '../../scripts/utilities/safe-local-storage';
import {
  ACTIVATE_PERSISTENT_LOGIN_POPUP,
  DISABLE_PERSISTENT_LOGIN_POPUP,
  RESET_CP_NUMBER,
  RESET_LOGIN_SUCCESS_COUNT,
  SET_SIGN_IN_STATE,
} from '../constants/action-types';
import Moment from 'moment';
import { sendNewRelicEvent } from '../../scripts/utilities/newrelic/newrelic-micro-sendEvent.js';
import { RESULT_STATE } from '../../scripts/utilities/newrelic/newrelic-constants.js';

const initialState = {
  checkSessionStart: false,
  codeInicativeAccount: '',
  codeFailCredentials: '',
  otpServiceError: false,
  errorActionable: '',
  errorActionType: '',
  errorExtraInfo: '',
  errorMsg: '',
  errorStatusCode: '',
  ffNumber: '',
  getOtpError: '',
  grantAccess: '',
  grantAccessError: null,
  grantAccessLoading: false,
  ipAddress: undefined,
  isActivePersistentLoginPopup: false,
  isSignIn: undefined,
  isInvalidSession: undefined,
  isOtpSent: undefined,
  isOtpValid: undefined,
  isValidSession: undefined,
  loadingPorfileRequestStart: false,
  remainingAttemptsRetrieveProfile: 3,
  loadingUserInfo: false,
  loginSuccessCount: 0,
  metrixEmail: '',
  metrixEmailCopy: '',
  sendOtpError: '',
  signInFail: undefined,
  signInFailCode: '',
  signUpFail: undefined,
  userActive: undefined,
  userFirstName: '',
  userInitials: '',
  userProfile: {},
  userProfileCPNumber: undefined,
  userProfLogout: undefined,
  userProfileSignUpSuccess: undefined,
  userToken: '',
  apiError : null,
};

const UserProfileSession = (state = initialState, action) => {
  switch (action.type) {
    // user's session
    case asyncActionTypes.SESSION_CHECKER.START:
      return {
        ...state,
        checkSessionStart: true,
        loadingPorfileRequestStart: true,
      };

    case asyncActionTypes.SESSION_CHECKER.SUCCESS:
      return {
        ...state,
        checkSessionStart: false,
        isValidSession: true,
        isInvalidSession: false,
        loadingPorfileRequestStart: false,
        userToken: action.token,
      };

    case asyncActionTypes.SESSION_CHECKER.FAIL:
      return {
        ...state,
        checkSessionStart: false,
        isValidSession: false,
        isInvalidSession: true,
        loadingPorfileRequestStart: false,
        userToken: '',
        userFirstName: '',
        userInitials: '',
      };
    // user login
    case asyncActionTypes.USER_SIGNIN.START:
      return {
        ...state,
        codeInicativeAccount: '',
        isSignIn: undefined,
        loadingPorfileRequestStart: true,
        metrixEmail: '',
        signInFail: undefined,
        signInFailCode: '',
        userActive: undefined,
        userFirstName: '',
        userInitials: '',
        userProfile: {},
        userToken: '',
      };

    case asyncActionTypes.USER_SIGNIN.SUCCESS:
      if (!action.payload.metrixEmail) {
        const showSuccessPage = state.loginSuccessCount !== 0;

        return {
          ...state,
          isSignIn: !showSuccessPage,
          loadingPorfileRequestStart: false,
          loginSuccessCount: state.loginSuccessCount + 1,
          userFirstName: action.userFirstName,
          userInitials: action.userInitials,
          userProfile: { ...action.payload.userProfile },
          userToken: action.payload.userToken,
        };
      } else {
        if (state.loginSuccessCount > 0) {
          state.loginSuccessCount = 0;
        }

        return {
          ...state,
          ffNumber: action.payload.ffNumber,
          loadingPorfileRequestStart: false,
          loginSuccessCount: state.loginSuccessCount + 1,
          metrixEmail: action.payload.metrixEmail,
          metrixEmailCopy: action.payload.metrixEmail,
        };
      }

    case asyncActionTypes.USER_SIGNIN.FAIL:
      return {
        ...state,
        loadingPorfileRequestStart: false,
        signInFail: true,
        signInFailCode: action.payload,
        userActive: true,
        codeInicativeAccount: (action.payload && typeof action.payload === 'string') ? action.payload : '',
      };

    case asyncActionTypes.REMOVE_CODE_ERROR:
      return {
        ...state,
        codeInicativeAccount: '',
      };

    case asyncActionTypes.REMOVE_STATUS_CODE_ERROR:
      return {
        ...state,
        errorStatusCode: '',
      };

    case asyncActionTypes.RETRIVE_USER_PROFILE.START:
      return {
        ...state,
        loadingPorfileRequestStart: true,
        loadingUserInfo: true,
      };
    case asyncActionTypes.USER_LOGOUT.START:
      return {
        ...state,
        loadingPorfileRequestStart: true,
      };
    case asyncActionTypes.RETRIVE_USER_PROFILE.SUCCESS:
      const savedBalance = safeLocalStorage.getItem('savedBalance');
      const userProfile = { ...action.payload.userProfile };
      if (savedBalance) {
        userProfile.account.balance = parseInt(savedBalance, 10);
      }
      return {
        ...state,
        loadingPorfileRequestStart: false,
        loadingUserInfo: false,
        isSignIn: true,
        userToken: action.token,
        userFirstName: action.userFirstName,
        userInitials: action.userInitials,
        userProfile: userProfile,
      };

    case asyncActionTypes.RETRIVE_USER_PROFILE.FAIL:
      return {
        ...state,
        loadingPorfileRequestStart: false,
        loadingUserInfo: false,
        errorMsg: action.payload.msg,
        remainingAttemptsRetrieveProfile: state.remainingAttemptsRetrieveProfile - 1,
      };

    case asyncActionTypes.USER_LOGOUT.SUCCESS:
      safeLocalStorage.removeItem('initials');
      safeLocalStorage.removeItem('firstName');
      deleteCookie('userSession');
      deleteCookie('userSessionCorporate');

      return initialState;
    case asyncActionTypes.GET_GRANT_ACCESS.START:
      if (action.payload.loading) {
        return {
          ...state,
          grantAccessLoading: true,
        };
      }

      return {
        ...state,
      };
    case asyncActionTypes.GET_GRANT_ACCESS.SUCCESS:
      const expiresGrantAccess = new Date();
      expiresGrantAccess.setTime(expiresGrantAccess.getTime() + (180000));

      const payloadGrantAccess = {
        from: 'MYB',
        GrantId: action.payload.grantAccess,
        timeExpiration: Moment(expiresGrantAccess).format(),
      };

      // LS and Cookie.
      if (action.payload.grantAccess) {
        setCookie('GAMYB', JSON.stringify(payloadGrantAccess), null, expiresGrantAccess);
        safeLocalStorage.setItem('GAMYB', JSON.stringify(payloadGrantAccess));
      }

      return {
        ...state,
        grantAccessLoading: false,
        grantAccess: action.payload.grantAccess,
      };
    case asyncActionTypes.GET_GRANT_ACCESS.FAIL:

      if (getCookie('GAMYB') || safeLocalStorage.getItem('GAMYB')) {
        deleteCookie('GAMYB');
        safeLocalStorage.removeItem('GAMYB');
      }

      return {
        ...state,
        grantAccessLoading: true,
        grantAccess: '',
        grantAccessError: action.payload,
      };
    case asyncActionTypes.GET_OTP.START:
      return {
        ...state,
        getOtpError: '',
        isOtpValid: undefined,
      };
    case asyncActionTypes.GET_OTP.SUCCESS:
      return {
        ...state,
        otpServiceError: initialState.otpServiceError,
        getOtpError: '',
        isOtpValid: true,
        apiError: null,
      };
    case asyncActionTypes.GET_OTP.FAIL:
      return {
        ...state,
        otpServiceError: action?.otpServiceError,
        getOtpError: action?.payload?.errorCode || action?.payload?.code,
        isOtpValid: false,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case asyncActionTypes.USER_LOGOUT.FAIL:
      return {
        ...state,
        loadingPorfileRequestStart: false,
        userProfLogout: false, // We'll need this in the future to send the correct error to GTM.
      };
    case asyncActionTypes.USER_ENROLLMENT.START:
      return {
        ...state,
        loadingPorfileRequestStart: true,
        apiError: null,
      };
    case asyncActionTypes.USER_ENROLLMENT.SUCCESS:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Enroll',
        state: action?.store,
        result: action?.payload,
        resultState: RESULT_STATE.SUCCESS,
      });

      return {
        ...state,
        loadingPorfileRequestStart: false,
        otpServiceError: initialState.otpServiceError,
        userProfileSignUpSuccess: true,
        userProfileCPNumber: action?.payload?.accountNumber,
        apiError: null,
      };
    case asyncActionTypes.USER_ENROLLMENT.FAIL:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Enroll',
        state: action?.store,
        result: action?.payload,
        resultState: RESULT_STATE.FAILURE,
      });

      return {
        ...state,
        loadingPorfileRequestStart: false,
        otpServiceError: action.otpServiceError,
        signUpFail: true,
        errorStatusCode: action.payload.errorCode,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case ACTIVATE_PERSISTENT_LOGIN_POPUP:
      return {
        ...state,
        isActivePersistentLoginPopup: true,
      };
    case DISABLE_PERSISTENT_LOGIN_POPUP:
      return {
        ...state,
        isActivePersistentLoginPopup: false,
      };
    case RESET_CP_NUMBER:
      return {
        ...state,
        userProfileCPNumber: initialState.userProfileCPNumber,
      };
    case RESET_LOGIN_SUCCESS_COUNT:
      return {
        ...state,
        loginSuccessCount: 0,
      };
    case SET_SIGN_IN_STATE:
      return {
        ...state,
        isSignIn: true,
      };
    case asyncActionTypes.SEND_OTP.START:
      return {
        ...state,
        isOtpSent: undefined,
        sendOtpError: '',
        loadingPorfileRequestStart: true,
      };
    case asyncActionTypes.SEND_OTP.SUCCESS:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Send OTP',
        state: action?.store,
        result: action?.payload,
        resultState: RESULT_STATE.SUCCESS,
      });

      return {
        ...state,
        otpServiceError: initialState.otpServiceError,
        isOtpSent: true,
        sendOtpError: '',
        apiError: null,
        loadingPorfileRequestStart: false,
      };
    case asyncActionTypes.SEND_OTP.FAIL:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Send OTP',
        state: action?.store,
        result: action?.payload,
        resultState: RESULT_STATE.FAILURE,
      });

      return {
        ...state,
        otpServiceError: action.otpServiceError,
        isOtpSent: false,
        sendOtpError: action?.payload?.message || action?.payload?.msg,
        loadingPorfileRequestStart: false,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case asyncActionTypes.ENROLLMENT_ERROR:
      return {
        ...state,
        otpServiceError: initialState.otpServiceError,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case asyncActionTypes.RETRIEVE_IP_ADDRESS:
      return {
        ...state,
        ipAddress: action?.payload,
      };
    default:
      return state;
  }
};

export default UserProfileSession;
